import { render } from "./account-switch.vue?vue&type=template&id=471ba338"
import script from "./account-switch.vue?vue&type=script&lang=js"
export * from "./account-switch.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__